import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { cn } from "$lib/utils.js";

var root = $.from_html(`<div><!></div>`);

export default function Card($$anchor, $$props) {
	$.push($$props, true);

	let ref = $.prop($$props, 'ref', 15, null),
		restProps = $.rest_props($$props, [
			'$$slots',
			'$$events',
			'$$legacy',
			'ref',
			'class',
			'children'
		]);

	var div = root();

	$.attribute_effect(div, ($0) => ({ 'data-slot': 'card', class: $0, ...restProps }), [
		() => cn("bg-card text-card-foreground flex flex-col gap-6 rounded-xl border py-6 shadow-sm", $$props.class)
	]);

	var node = $.child(div);

	$.snippet(node, () => $$props.children ?? $.noop);
	$.reset(div);
	$.bind_this(div, ($$value) => ref($$value), () => ref());
	$.append($$anchor, div);
	$.pop();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiY2FyZC5zdmVsdGUiXSwic291cmNlc0NvbnRlbnQiOlsiPHNjcmlwdCBsYW5nPVwidHNcIj5cblx0aW1wb3J0IHR5cGUgeyBIVE1MQXR0cmlidXRlcyB9IGZyb20gXCJzdmVsdGUvZWxlbWVudHNcIjtcblx0aW1wb3J0IHsgY24sIHR5cGUgV2l0aEVsZW1lbnRSZWYgfSBmcm9tIFwiJGxpYi91dGlscy5qc1wiO1xuXG5cdGxldCB7XG5cdFx0cmVmID0gJGJpbmRhYmxlKG51bGwpLFxuXHRcdGNsYXNzOiBjbGFzc05hbWUsXG5cdFx0Y2hpbGRyZW4sXG5cdFx0Li4ucmVzdFByb3BzXG5cdH06IFdpdGhFbGVtZW50UmVmPEhUTUxBdHRyaWJ1dGVzPEhUTUxEaXZFbGVtZW50Pj4gPSAkcHJvcHMoKTtcbjwvc2NyaXB0PlxuXG48ZGl2XG5cdGJpbmQ6dGhpcz17cmVmfVxuXHRkYXRhLXNsb3Q9XCJjYXJkXCJcblx0Y2xhc3M9e2NuKFxuXHRcdFwiYmctY2FyZCB0ZXh0LWNhcmQtZm9yZWdyb3VuZCBmbGV4IGZsZXgtY29sIGdhcC02IHJvdW5kZWQteGwgYm9yZGVyIHB5LTYgc2hhZG93LXNtXCIsXG5cdFx0Y2xhc3NOYW1lXG5cdCl9XG5cdHsuLi5yZXN0UHJvcHN9XG4+XG5cdHtAcmVuZGVyIGNoaWxkcmVuPy4oKX1cbjwvZGl2PlxuIl0sIm1hcHBpbmdzIjoiOztTQUVVLEVBQUUsUUFBNkIsZUFBZTs7OztnREFGeEQsQ0FBQzs7O0tBS0MsR0FBRyw4QkFBYSxJQUFJO0VBR2pCLFNBQVM7Ozs7Ozs7Ozs7O3VFQVdULFNBQVM7UUFKTixFQUFFLENBQ1IsbUZBQW1GOzs7Ozs7OytCQUh6RSxHQUFHLGlCQUFILEdBQUc7OztBQUhoQixDQUFDIn0=